var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"mdc-button"},'button',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"mdc-button__ripple"}),_c('span',{staticClass:"mdc-button__label"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }